<template>
  <div
    class="forms"
    :style="{
      background: `url(${itemData.backgroundUrl}?x-oss-process=image/resize,w_750/quality,q_80) top center / 100% auto no-repeat`,
      padding: `${computedStyle(itemData.padding.top)}px ${computedStyle(
        itemData.padding.right
      )}px ${computedStyle(itemData.padding.bottom)}px ${computedStyle(
        itemData.padding.left
      )}px`,
    }"
  >
    <div class="form_box" id="formBox">
      <van-form :validate-first="true">
        <van-field
          v-model.trim="infoForm.name"
          placeholder="请输入您的姓名"
          :maxlength="10"
          :style="{
            height: `${computedStyle(itemData.form.height)}px`,
            marginBottom: `${computedStyle(itemData.form.marginBottom)}px`,
          }"
        />
        <van-field
          v-model.trim="infoForm.telphone"
          placeholder="请输入手机号码"
          :maxlength="11"
          :style="{
            height: `${computedStyle(itemData.form.height)}px`,
            marginBottom: `${computedStyle(itemData.form.marginBottom)}px`,
          }"
        />
        <van-field
          v-model.trim="infoForm.codes"
          center
          clearable
          placeholder="请输入验证码"
          :maxlength="6"
          :style="{
            height: `${computedStyle(itemData.form.height)}px`,
            marginBottom: `${computedStyle(itemData.form.marginBottom)}px`,
          }"
        >
          <template #button>
            <van-button
              class="send-btn"
              :round="Boolean(itemData.form.isRound)"
              :style="{
                color: itemData.form.btnColor,
                background: itemData.form.btnbg,
              }"
              size="mini"
              :disabled="isSend"
              type="info"
              @click="sendSms"
              >{{ isSend ? `${num}s` : smsText }}</van-button
            >
          </template>
        </van-field>
        <van-field
          readonly
          clickable
          name="area"
          :value="infoForm.location"
          placeholder="请选择所在城市"
          @click="showArea = true"
          :style="{
            height: `${computedStyle(itemData.form.height)}px`,
            marginBottom: `${computedStyle(itemData.form.marginBottom)}px`,
          }"
        />
        <van-popup v-model="showArea" position="bottom">
          <van-area
            :area-list="areaList"
            @confirm="onConfirm"
            @cancel="showArea = false"
            :columns-num="3"
          />
        </van-popup>
        <div class="protect" v-if="Boolean(itemData.form.showTreaty)">
          <van-checkbox v-model="checked"
            ><span class="label"
              >勾选表示同意
              <b
                class="label"
                @click.stop="
                  () => {
                    show = true;
                  }
                "
                >《个人信息授权与保护声明》</b
              >
            </span></van-checkbox
          >
        </div>
        <div>
          <van-button
            class="bg-btn"
            block
            :round="Boolean(itemData.form.isRound)"
            :style="{
              color: itemData.form.btnColor,
              background: itemData.form.btnImg
                ? `transparent url(${itemData.form.btnImg}?x-oss-process=image/resize,w_300/quality,q_80) no-repeat center center / contain`
                : `${itemData.form.btnbg}`,
            }"
            type="info"
            native-type="submit"
            @click="onSubmit"
            data-sensors-click
            name="submit-click"
            >{{ itemData.form.btnText }}</van-button
          >
        </div>
      </van-form>
      <van-dialog v-model="show" title="个人信息授权与保护声明">
        <div class="content">
          <p>
            我们非常重视用户信息的保护。您在使用我们的服务时，我们可能会收集和使用您的相关信息。我们希望通过本声明向您说明在适用于具体的留资场景时我们如何收集、使用、共享、保护您的信息，以进一步保障您的信息安全和为您提供更具个性化的优质服务。在使用我们的留资服务（以下简称“服务”），并在相应页面填写相关信息前，请您务必仔细阅读本声明。您一旦主动在相应页面填写信息并进行提交操作，即意味着您同意我们按照本声明收集、使用、共享您的相关信息。
          </p>
          <p>一、个人信息的收集</p>

          <p>
            1、我们提供服务时，可能会收集您的姓名、手机号。请您注意，具体需要填写的信息可能会根据我们提供的产品/服务的不同而有所差异，请以届时向您展示的服务以及所对应的要求填写相关个人信息，但我们会在下文向您说明我们可能收集的全部个人信息的收集和使用规则。
          </p>
          <p>
            2、您需要注意的是，以上个人信息均是您自愿提供。您有权拒绝提供，但可能无法正常使用相应的服务、功能或者无法达到服务拟达到的效果。
          </p>
          <p>
            3、对于不满 18
            岁的用户，须在其监护人陪同未成年人用户已经阅读和理解本声明并且许可的情况下向我们提交相关个人信息。
          </p>

          <p>二、个人信息的使用和共享</p>

          <p>1、您同意，我们可以通过以下方式对个人信息进行使用和共享：</p>

          <p>
            ①为了保障你能正常使用由我们、我们的关联方或合作方提供的相关功能或服务，或为保障使用安全或进行必要的产品使用分析，我们可能会收集使用或者与上述各方共享所必需的信息（例如您使用服务的相关日志信息）；
          </p>
          <p>
            ②我们接受您留资所对应的相关业务客户的委托，向其共享您在表单中主动提供的信息，并由其在合法正当以及您已经向其授权的范围内使用（例如与您及时进行联络）。此外，为保证您获得更好的服务体验，我们可能会与前述客户共享难以识别您个人身份的必要的用户画像标签信息并由其在合法正当的范围内使用（例如促使相关联络内容、联络时间更符合您的要求）；
          </p>
          <p>③我们和关联公司为满足您的需求，可能通过您提供的信息与您联系；</p>
          <p>
            ④我们和关联公司可能定期或不定期向您发送有关产品、服务或相关活动的信息；
          </p>
          <p>
            ⑤经您授权同意后，您已知晓并同意在您下次浏览落地页面时，我们会帮您预先填写您上次输入的历史信息以提升您的使用体验，且只有您点击提交按钮之后才会传输给关联公司、客户。若您拒绝使用预填充功能，或者拟撤回使用预填充功能的授权，您可以根据产品所提供的功能进行。但也请您注意，您一旦拒绝或撤回授权，您将无法使用预填充功能，但您仍然可以主动输入相关信息并继续使用我们的产品/服务。
          </p>
          <p>
            ⑥基于我们与通信运营商的合作，当您点击“使用本机号码”时，经过您的明示同意，运营商会将您的手机号码发送给我们，便于我们为您提供快捷提交服务。您也可以自主选择手动填写手机号码的方式提交。
          </p>
          <p>
            ⑦如您拟撤回授权/删除您提交的个人信息的，您可以通过APP内用户反馈入口与我们联系，我们将尽快配合处理，如相关客户在您撤回授权或申请删除前已经获得了您的相关信息，我们会敦促其响应您的诉求并要求其删除您的相关信息。
          </p>

          <p>
            2、我们将严格保护您的个人信息安全。我们将采用适当制度、安全技术和程序等措施来保护您的个人信息不被未经授权的访问、使用或泄漏。我们亦将促使本声明所述各接收和使用方尽力保护和不予泄露您的个人信息。
          </p>

          <p>
            3、我们将要求并敦促个人信息接收方遵循本声明和法律法规的规定，谨慎使用其接收到的个人信息，如其发生超越本声明范围使用您的个人信息，进而侵害您合法权益的情形，我们将协助您追究该接收方的法律责任。
          </p>

          <p>三、适用法律</p>

          <p>1、本声明适用中华人民共和国法律。</p>

          <p>
            2、如果您对信息保护问题有任何疑问或选择取消授权的，您可以通过APP内用户反馈入口联系我们。
          </p>

          <p>四、变更</p>
          <p>
            我们会适时对本声明进行修订，该等修订构成本声明的一部分。公司（即【慕思健康睡眠股份有限公司】）会将修改后的声明予以发布。在该种情况下，若您继续使用我们的服务，即表示同意接受经修订的声明的约束。
          </p>
        </div>
      </van-dialog>
    </div>
  </div>
</template>
<script>
import { areaList } from "@vant/area-data";
import { sendMessege, verifySnsCode, adSignUp } from "@/api/common.js";
import { nameReg, phoneReg } from "@/utils/validateReg.js";
import { randomString } from "@/utils";

const initForm = () => {
  return {
    name: "",
    telphone: "",
    codes: "",
    location: "",
  };
};

export default {
  props: {
    itemData: {
      type: Object,
      default: {
        padding: {
          top: "0",
          right: "30",
          bottom: "0",
          left: "30",
        },
      },
    },
    title: {
      type: String,
      default: "DeRUCCI 慕思",
    },
    activityUrl: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      infoForm: initForm(),
      checked: false,
      areaList,
      showArea: false,
      show: false,
      loading: false,
      smsText: "发送验证码",
      isSend: false,
      num: 60,
      timer: null,
    };
  },
  created() {},
  methods: {
    computedStyle(num) {
      return (num * document.documentElement.clientWidth) / 323;
    },
    sendSms() {
      const { telphone } = this.infoForm;
      if (!telphone) {
        this.$toast("手机号码必填");
        return;
      }
      if (!phoneReg.test(telphone)) {
        this.$toast("手机号码格式不正确");
        return;
      }
      if (!this.isSend) {
        const params = {
          project: this.title, // 调用项目：CRM
          phone: telphone, // 调用电话：多个时用分号隔开，上限500个
          signName: "慕思", // 签名：慕思
          tempCode: "SMS_198691885", // 模板code: SMS_182541596
          operType: "CAPTCHA", // 操作类型：CAPTCHA 验证码类短信、NOTE 通知类短信
          tempParam: "{}", // 模板中的变量，json字符串，验证码code非空时，直接进行验证码处理，验证码code为空时，由接口自动生成
          mhzTime: 1, // 验证码发送频率时长，范围：1分钟~2分钟，默认：1分钟
          validTime: 5, // 验证码有效时间，范围：5分钟~30分钟，默认：5分钟
        };
        this.isSend = true;
        sendMessege(params).then((res) => {
          this.$toast(res.msg);
        });
        this.timer = setInterval(() => {
          if (this.num > 0) {
            this.num--;
          } else {
            clearInterval(this.timer);
            this.isSend = false;
            this.num = 60;
          }
        }, 1000);
      }
    },
    async onSubmit() {
      const { name, telphone, location, codes } = this.infoForm;
      const adress = location.split("/");

      if (!name) {
        this.$toast("姓名必填");
        return;
      }
      if (!telphone) {
        this.$toast("手机号码必填");
        return;
      }
      if (!codes) {
        this.$toast("验证码必填");
        return;
      }
      if (!location) {
        this.$toast("所在城市必填");
        return;
      }
      if (!nameReg.test(name)) {
        this.$toast("姓名格式不正确");
        return;
      }
      if (!phoneReg.test(telphone)) {
        this.$toast("手机号码格式不正确");
        return;
      }

      if (this.itemData.form.showTreaty && !this.checked) {
        this.$toast("请勾选并同意个人信息授权与保护声明");
        return;
      }

      try {
        const { code, msg } = await verifySnsCode({
          phone: telphone,
          verifyCode: codes,
        });

        if (code != 0) {
          this.$toast(msg);
          return;
        }
      } catch (err) {
        console.log(err);
      }

      const data = {
        name: name,
        telphone: telphone,
        codes: "",
        fy_location: `${adress[0]}+${adress[1]}`,
        confId: this.$route.query.confId,
        siteName: document.title || "慕思活动落地页",
        external_url: this.activityUrl || window.location.href,
        clueId: randomString(18),
      };

      adSignUp(data)
        .then((res) => {
          if (res.code == 0) {
            this.$toast("提交成功");
            this.infoForm = initForm();
            const params = {
              name,
              phone_num: btoa("5345" + this.infoForm.telphone + "74826"),
              province: adress[0],
              city: adress[1],
            };

            try {
              this.$sensors.login(btoa("5345" + telphone + "74826"));
              //神策
              this.$sensors.track("SubMitInfor", params);
              this.$sensors.setProfile({
                nick_name: name,
                phone: btoa("5345" + telphone + "74826"),
                resuster_time: +new Date(),
              });

              // 抖音广告
              if (
                this.$route.query.assetsId &&
                this.$route.query.source == "douyin"
              ) {
                //"1718658484712452"
                _baq.track("form", {
                  assets_id: this.$route.query.assetsId,
                  ...params,
                  phone_num: telphone,
                });
              }

              //快手
              if (
                this.$route.query.convertId &&
                this.$route.query.source == "kuaishou"
              ) {
                _ks_trace.push({
                  event: "form",
                  convertId: this.$route.query.convertId,
                  cb: function () {
                    console.log("Your callback function here!");
                  },
                });
              }

              //b站
              if (this.$route.query.source == "bilibili") {
                window.bilicm.mbase.report_data();
              }
            } catch (err) {
              console.log(err);
            }
          } else {
            this.$toast(res.message);
          }
        })
        .catch((err) => {
          console.log(err);
          this.$toast("提交失败");
        });
    },
    onConfirm(values) {
      let strArr = [];
      values.map((item) => {
        strArr.push(item.name);
      });
      this.infoForm.location = strArr.join("/");
      this.showArea = false;
    },
  },
};
</script>
<style scoped lang="scss">
::v-deep .van-form {
  .van-field__value {
    display: flex;
  }
  .van-field__body {
    width: 100%;
  }
  .van-cell {
    background: #fff;
    border: none;
    margin-bottom: 15px;
    padding: 5px 20px;
    border-radius: 5px;
    font-size: 12px;
    .van-field__label {
      color: #8d8d8d;
    }
  }
  .van-field__control {
    color: #000;
  }
  .van-cell .van-button--info {
    background-color: #1989fa;
    border-color: #1989fa;
  }
  .van-checkbox__label {
    margin-left: 0;
    .label {
      font-size: 12px;
      font-weight: bold;
      color: #1989fa;
      line-height: 1;
      display: flex;
      align-items: center;
      margin-left: 0;
    }
  }

  .van-checkbox {
    display: flex;
    align-items: center;
  }
  .van-checkbox__icon {
    transform: scale(0.7);
  }
  input::-webkit-input-placeholder {
    color: #c3c3c3;
  }
  .van-checkbox__label {
    display: flex;
    align-items: center;
    font-size: 10px;
  }
  .van-checkbox__icon {
    width: 14px;
    height: 14px;
    line-height: 14px;
  }
  .van-checkbox__icon .van-icon {
    width: 14px;
    height: 14px;
    line-height: 14px;
    font-size: 12px;
  }
}
// .forms {
//   background-repeat: no-repeat;
//   background-size: 100% auto;
// }
.report {
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  height: 50px;
  width: 100%;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9;
  background-color: #395cce;
  color: #fff;
}

.bg-btn {
  //   background: url(~@/assets/818/按钮.png) center center no-repeat;
  background-size: contain;
  border: none;
  height: 40px;
}
.send-btn {
  border: none;
}
.img {
  display: block;
  margin: 0 auto;
  width: 100%;
}

.van-cell::after {
  border: none;
}

.van-button--normal {
  font-size: 20px;
  font-weight: bold;
}
.protect {
  margin-bottom: 10px;
  display: flex;
  /* flex-direction: row; */
  align-items: center;
}

.label {
  color: #8d8d8d;
}
.content {
  height: 400px;
  overflow-y: auto;
  padding: 10px;
  white-space: pre-wrap;
  line-height: 2;
  font-size: 12px;
}
.explain {
  font-size: 12px;
  margin-top: 20px;
  color: #27447e;
  text-align: center;
}
</style>
